export default {"src":"/_next/static/media/TransferDark.6ced65e9.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};